module.exports = __webpack_public_path__ + "img/EnteringAC.408d85ea.jpg";